import type { SupplierFilters } from "./supplierFilters";
import { EMPTY_PERIOD } from "./ContractRangeInputs";

export type SupplierFilterKey = "relations" | "counties" | "municipalities" | "naceCodes" | "endDate" | `contract:${string}`;

export const contractFilterKey = (fieldId: string): SupplierFilterKey => `contract:${fieldId}`;

const contractFieldId = (key: SupplierFilterKey): string | null =>
  key.startsWith("contract:") ? key.slice("contract:".length) : null;

const without = <T,>(values: Record<string, T>, fieldId: string): Record<string, T> =>
  Object.fromEntries(Object.entries(values).filter(([id]) => id !== fieldId));

export const hasFilterValue = (filters: SupplierFilters, key: SupplierFilterKey): boolean => {
  const fieldId = contractFieldId(key);
  if (fieldId !== null) {
    const period = filters.periods[fieldId];
    return (
      (filters.contractFields[fieldId]?.length ?? 0) > 0 ||
      filters.lowestValues[fieldId] !== undefined ||
      Boolean(period?.from || period?.to)
    );
  }
  if (key === "relations") return filters.relations.length + filters.withoutRelations.length > 0;
  if (key === "endDate") return Boolean(filters.endDate.from || filters.endDate.to);
  return filters[key as "counties" | "municipalities" | "naceCodes"].length > 0;
};

export const withoutFilter = (filters: SupplierFilters, key: SupplierFilterKey): SupplierFilters => {
  const fieldId = contractFieldId(key);
  if (fieldId !== null) {
    return {
      ...filters,
      contractFields: without(filters.contractFields, fieldId),
      lowestValues: without(filters.lowestValues, fieldId),
      periods: without(filters.periods, fieldId),
    };
  }
  if (key === "relations") return { ...filters, relations: [], withoutRelations: [] };
  if (key === "endDate") return { ...filters, endDate: EMPTY_PERIOD };
  return { ...filters, [key]: [] };
};
